var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 15C5.40625 15 3.63281 14.2734 2.17969 12.8203C0.726562 11.3672 0 9.59375 0 7.5C0 5.40625 0.726562 3.63281 2.17969 2.17969C3.63281 0.726562 5.40625 0 7.5 0C8.57812 0 9.60938 0.222656 10.5938 0.667969C11.5781 1.11328 12.4219 1.75 13.125 2.57812V0H15V6.5625H8.4375V4.6875H12.375C11.875 3.8125 11.1914 3.125 10.3242 2.625C9.45703 2.125 8.51562 1.875 7.5 1.875C5.9375 1.875 4.60938 2.42188 3.51562 3.51562C2.42188 4.60938 1.875 5.9375 1.875 7.5C1.875 9.0625 2.42188 10.3906 3.51562 11.4844C4.60938 12.5781 5.9375 13.125 7.5 13.125C8.70312 13.125 9.78906 12.7812 10.7578 12.0938C11.7266 11.4062 12.4062 10.5 12.7969 9.375H14.7656C14.3281 11.0312 13.4375 12.3828 12.0938 13.4297C10.75 14.4766 9.21875 15 7.5 15Z",
    fill: "#FCF2FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/reload.f259a8b241f13d4aa3e12b116e1199b1.svg";
export { ForwardRef as ReactComponent };